import module from 'fanconsultores/module.js'

class AdminDashboardService {
  constructor (Permisos, $http) {
    this.Permisos = Permisos
    this.$http = $http
  }

  get () {
    return this.$http.get('/api/dashboard')
  }

  permisosFinanzas () {
    return this.Permisos.modulos({
      transferenciaRecursos: 'kendu.finanzas.transferenciaRecursos',
      gastosVsBancos: 'Finances.gastos_bancos',
      detallesFacturacion: 'Payrolls.billings',
      saldoEmpleados: 'finances.services.saldos_empleados_x_concepto',
      serviciosAgregados: 'Services.summary_by_date',
      divisas: 'finances.divisas',
      tablaRelacional: 'kendu.finanzas.tablaRelacional',
      cuentasBancarias: 'kendu.finanzas.cuentasBancarias',
      cargarMovimientosBancos: 'kendu.finances.cargarMovimientosBancos',
      comisionistas: 'finanzas.comisionitas',
      reporteFacturas: 'finanzas.reporteFacturas',
      empresasfacturado: 'finanzas.empresasfacturado',
      reportecomisiones: 'finanzas.reportecomisiones',
      clasificarmovimientos: 'finanzas.clasificarmovimientos',
      saldosfacturacion: 'finanzas.saldosfacturacion',
      empleadoprestamos: 'finanzas.empleadoprestamos',
      cheques: 'finanzas.cheques',
      posicionbancaria: 'finanzas.posicionbancaria',
    })
  }

  permisosContabilidad () {
    return this.Permisos.modulos({
      polizas: 'contabilidad.polizas',
      cheques: 'contabilidad.cheques',
      clientesCuentasContables: 'contabilidad.clientesCuentasContables',
      asociarfacturas: 'contabilidad.asociarfacturas',
      reportenominasmovimientos: 'contabilidad.reportenominasmovimientos',
      reporteisn: 'contabilidad.reporteisn',
      polizasexternas: 'contabilidad.polizasexternas',
      catalogosexternos: 'contabilidad.catalogosexternos',
      reportesexternos: 'contabilidad.reportesexternos',
      declaracionisn: 'contabilidad.declaracionisn',
    })
  }

  permisosRecursosHumanos () {
    return this.Permisos.modulos({
      cargarMovimientos: 'recursoshumanos.cargamovimientos',
      comparativaSuaNomina: 'recursoshumanos.suavsnomina',
      dictamenColaboradores: 'recursoshumanos.dictamenColaboradores',
      dictamenIncidencias: 'recursoshumanos.dictamenIncidencias',
      dictamenPuestos: 'recursoshumanos.dictamenPuestos',
      reporteIncapacidades: 'recursoshumanos.incapacidades',
      reporteRetencionInfonavit: 'recursoshumanos.retencioninfonavit',
      pagosSua: 'recursoshumanos.pagossua',
      visorLotes: 'recursoshumanos.visorlotes',
    })
  }

  permisosFacturacion () {
    return this.Permisos.modulos({
      permisos: 'permisos',
      pagina: 'facturacion.pagina',
      notificacioncorreo: 'facturacion.notificacioncorreo',
      manual: 'facturacion.manual',
      folios: 'facturacion.folios',
      facturas: 'facturacion.facturas',
      facturacionrapida: 'facturacion.facturacionrapida',
      facturacionprevia: 'facturacion.facturacionprevia',
      facturacion: 'facturacion.facturacion',
      empresas: 'facturacion.empresas',
      direccionfiscalempresas: 'facturacion.direccionfiscalempresas',
      direccionfiscalclientes: 'facturacion.direccionfiscalclientes',
      conceptoscontables: 'facturacion.conceptoscontables',
      conceptos: 'facturacion.conceptos',
      clientes: 'facturacion.clientes',
      cancelar: 'facturacion.cancelar',
    })
  }

  permisosViaticos () {
    return this.Permisos.modulos({
      administrador: 'viaticos.administrador',
      configuracion: 'viaticos.configuracion',
      pendientes: 'viaticos.pendientes',
      pagos: 'viaticos.pagos',
      cancelarpago: 'viaticos.cancelarpago',
    })
  }
}

module.service('AdminDashboard', AdminDashboardService)



// WEBPACK FOOTER //
// ./src/fanconsultores/services/Admin/Dashboard.js